import { AuthenticatedUser } from '@contexts/Shared';
import { DniType } from './../../../domain';

export type UpdateTenantInformationResponseDto = {
  updateUserInfo: {
    value: string;
  };
};

export type UpdateTenantInformationRequestDto = {
  user: {
    firstName: string;
    lastName: string;
    email: string;
    identityDocumentCode: string;
    identityDocumentType: DniType;
  };
};

export const mapUpdateTenantInformationDomainToDto = (user: AuthenticatedUser): UpdateTenantInformationRequestDto => ({
  user: {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    identityDocumentType: user.identityDocumentType as DniType,
    identityDocumentCode: user.identityDocumentCode,
  }
});